<template>
  <div class="app-layout-root">
    <!-- Header is rendered once in App.vue to avoid duplicate nav bars and broken mobile menus -->
    <div class="app-content">
      <slot />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: 'AppLayout',
  mounted() {
    const adjust = () => {
      try {
        const hdr = document.getElementById('header')
        const app = document.querySelector('.app-content')
        if (hdr && app) {
          // compute header height and set CSS variable so all components can align
          const h = Math.ceil(hdr.getBoundingClientRect().height) || 0
          // set CSS custom property on root so other layouts can consume it
          document.documentElement.style.setProperty('--app-header-height', h + 'px')
          app.style.paddingTop = h + 'px'
        }
      } catch (e) {
        // ignore
      }
    }
    this.__appLayoutResizeHandler = () => adjust()
    // initial adjust
    adjust()
    window.addEventListener('resize', this.__appLayoutResizeHandler)
  },
  beforeUnmount() {
    if (this.__appLayoutResizeHandler) window.removeEventListener('resize', this.__appLayoutResizeHandler)
  },
};
</script>

<style scoped>
.app-header {
  background: #2c3e50;
  color: #fff;
  padding: 1rem;
  text-align: center;
}
main {
  padding: 2rem;
}
.app-content { padding-top: 60px; }
@media (max-width: 767px) {
  .app-content { padding-left: 12px; padding-right: 12px; }
}
</style>

<style>
/* reset default body margin to avoid top gap */
html { box-sizing: border-box; font-size: 100%; }
*, *:before, *:after { box-sizing: inherit; }
/* default header height fallback; runtime will update --app-header-height */
:root { --app-header-height: 60px; }
body { margin: 0; }
</style>
